













import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TrialCancellationContainer from 'frontend/views/premium/cancellation/components/TrialCancellationContainer.vue';
import FlagBasedSurvey from 'frontend/views/premium/cancellation/components/FlagBasedSurvey.vue';
import {
  CancellationFlowDirection,
  CancellationFlowEventfulRouteIndex,
  SurveyOption,
} from 'frontend/views/premium/cancellation/types';
import {
  cancellationApi,
  defaultAbortEventfulRoute,
  defaultNextEventfulRoute,
} from 'frontend/views/premium/cancellation/utils';

type DifferentPlanSurveyIdentifier =
  | 'gift_subscription'
  | 'group_subscription'
  | 'monthly_subscription'
  | 'lifetime_plan'
  | 'other';

@Component({
  components: {
    TrialCancellationContainer,
    FlagBasedSurvey,
  },
  computed: {},
})
export default class TrialCancellationPlanSurvey extends Vue {
  private loading = false;

  private chosenOption: SurveyOption<DifferentPlanSurveyIdentifier> | null = null;

  private options: Array<SurveyOption<DifferentPlanSurveyIdentifier>> = [
    {
      identifier: 'gift_subscription',
      verbose: 'Gift subscription',
    },
    {
      identifier: 'group_subscription',
      verbose: 'Group subscription',
    },
    {
      identifier: 'monthly_subscription',
      verbose: 'Monthly subscription',
    },
    {
      identifier: 'lifetime_plan',
      verbose: 'Lifetime plan',
    },
    {
      identifier: 'other',
      verbose: 'Other',
    },
  ];

  private eventfulRouteIndex: CancellationFlowEventfulRouteIndex<DifferentPlanSurveyIdentifier> = {
    gift_subscription: {
      next: defaultNextEventfulRoute(),
      abort: {
        event: 'clicked_trial_cancellation_gift_purchase',
        route: { name: 'gift_purchase_plans' },
      },
    },
    group_subscription: {
      next: {
        event: 'clicked_trial_cancellation_continue_cancellation',
        route: {
          name: 'payment_trial_cancel_different_plan_status',
          params: { option: 'group_subscription' },
        },
      },
      abort: defaultAbortEventfulRoute(),
    },
    monthly_subscription: {
      next: {
        event: 'clicked_trial_cancellation_continue_cancellation',
        route: {
          name: 'payment_trial_cancel_different_plan_status',
          params: { option: 'monthly_subscription' },
        },
      },
      abort: {
        event: 'clicked_trial_cancellation_keep_trial_confirm',
        route: { name: 'explorations_menu' },
      },
    },
    lifetime_plan: {
      next: {
        event: 'clicked_trial_cancellation_continue_cancellation',
        route: {
          name: 'payment_trial_cancel_different_plan_status',
          params: { option: 'lifetime_plan' },
        },
      },
      abort: defaultAbortEventfulRoute(),
    },
    other: {
      next: defaultNextEventfulRoute(),
      abort: defaultAbortEventfulRoute(),
    },
  };

  private async actionHandler(direction: CancellationFlowDirection): Promise<void> {
    this.loading = true;
    const { handleTrackedRedirect } = cancellationApi(this.eventfulRouteIndex);
    await handleTrackedRedirect(direction, this.chosenOption?.identifier, this.$router);
  }

  private choseOption(option: DifferentPlanSurveyIdentifier): void {
    this.chosenOption = this.options.find(o => o.identifier === option) || null;
  }

  private get abortBtnTextOverride(): string | undefined {
    return this.chosenOption?.identifier === 'gift_subscription' ? 'Purchase a gift' : undefined;
  }
}
